module.exports = __webpack_public_path__ + "static/chat-7c2c118e0ce7f6d4715faaed38859d49.jpeg";